/** Kanban カードの面談日・期限シグナル（PP/BP 共通） */

function parseDateOnly(value) {
  if (!value) return null;
  const s = String(value).slice(0, 10);
  const d = new Date(`${s}T00:00:00`);
  return Number.isNaN(d.getTime()) ? null : d;
}

function startOfDay(date = new Date()) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

function dayDiff(from, to) {
  return Math.round((to.getTime() - from.getTime()) / 86400000);
}

/** 面談日表示（truncate 回避・コンパクト） */
export function formatKanbanInterviewLine(interviewDate, interviewTime) {
  if (!interviewDate) return '未定';
  const d = parseDateOnly(interviewDate);
  if (!d) return String(interviewDate);
  const line = `${d.getMonth() + 1}/${d.getDate()}`;
  return interviewTime ? `${line} ${interviewTime}` : line;
}

/** 期限日表示 */
export function formatKanbanDeadlineLine(deadlineValue) {
  if (!deadlineValue) return '—';
  const d = parseDateOnly(deadlineValue);
  if (!d) return String(deadlineValue);
  return `${d.getMonth() + 1}/${d.getDate()}`;
}

export function getInterviewUrgency(interviewDate) {
  if (!interviewDate) return null;
  const interviewDay = parseDateOnly(interviewDate);
  if (!interviewDay) return null;
  const diff = dayDiff(startOfDay(), interviewDay);
  if (diff === 0) return { label: '今日', variant: 'info' };
  if (diff === 1) return { label: '明日', variant: 'info' };
  return null;
}

export function getDeadlineUrgency(deadlineValue) {
  if (!deadlineValue) return null;
  const deadlineDay = parseDateOnly(deadlineValue);
  if (!deadlineDay) return null;
  const diff = dayDiff(startOfDay(), deadlineDay);
  if (diff < 0) return { label: '期限超過', variant: 'danger' };
  if (diff <= 3) {
    if (diff === 0) return { label: '今日まで', variant: 'warning' };
    return { label: `あと${diff}日`, variant: 'warning' };
  }
  return null;
}

export function getSchedulingUndecidedSignal(status, interviewDate) {
  const s = String(status || '');
  if (!s.startsWith('日程調整中')) return null;
  if (interviewDate) return null;
  return { label: '未定', variant: 'neutral' };
}

/** 左ボーダー + シグナル一覧 */
export function resolveKanbanCardSignals({ status, interviewDate, deadlineValue }) {
  const interviewUrgency = getInterviewUrgency(interviewDate);
  const deadlineUrgency = getDeadlineUrgency(deadlineValue);
  const undecided = getSchedulingUndecidedSignal(status, interviewDate);

  let borderClass = 'border-l-prodia-border/50';
  if (deadlineUrgency?.variant === 'danger') {
    borderClass = 'border-l-danger';
  } else if (deadlineUrgency?.variant === 'warning') {
    borderClass = 'border-l-warning';
  } else if (interviewUrgency?.label === '今日') {
    borderClass = 'border-l-info';
  } else if (undecided) {
    borderClass = 'border-l-prodia-text-muted';
  }

  return {
    borderClass,
    interviewUrgency,
    deadlineUrgency,
    undecided,
  };
}
